module.exports = __webpack_public_path__ + "static/media/erigon-bg.363c42dd.png";